import CrudCustom from '../../../libs/custom/CrudCustom';

let MetodePenyusutanService = new CrudCustom('/metode-penyusutans');
export default MetodePenyusutanService;
